import toolbarUrl from "webutils/ibox/ibox.toolbar.htm";
import toolbarCloseUrl from "webutils/ibox/ibox.toolbar.close.htm";
import toolbarMenuUrl from "webutils/ibox/ibox.toolbar.menu.htm";
import toolbarToggleUrl from "webutils/ibox/ibox.toolbar.toggle.htm";
import toolbarIconUrl from "webutils/ibox/ibox.toolbar.icon.htm";

export class IboxDependentController {
  constructor() {}
  toggle() {
    return (this.collapsed = !this.collapsed);
  }
}

export default {
  require: {
    ibox: "^",
  },
  bindings: {
    icon: "@",
    type: "@",
    ngDisabled: "<",
    label: "@",
  },
  transclude: true,
  controller: IboxDependentController,
  templateUrl($element, $attrs) {
    if ($attrs.templateUrl) return $attrs.templateUrl;
    if ($attrs.type === "toolbar") return toolbarUrl;
    if ($attrs.type === "close") return toolbarCloseUrl;
    if ($attrs.type === "toggle") return toolbarToggleUrl;
    if ($attrs.type === "menu") return toolbarMenuUrl;
    if ($attrs.type === "icon") return toolbarIconUrl;
    return toolbarUrl;
  },
};
